import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import swal from "sweetalert"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import { customStyles } from "helpers/select-styles"
import Select from "react-select"
import moment from "moment"
import CustomEditor from "components/Common/CustomEditor"
import LogsOnPopup from "./LogsOnPopup"
import secureLocalStorage from "react-secure-storage"

const AddManualLogs = () => {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const [tasksOptions, settasksOptions] = useState([])
  const [worksTypeOptions, setworksTypeOptions] = useState([])
  const [clientOptions, setclientOptions] = useState([])
  const [statusOptions, setstatusOptions] = useState([])
  const [servicesOptions, setservicesOptions] = useState([])

  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [totalHours, setTotalHours] = useState("0.00")
  const [client, setClient] = useState(null)
  const [workType, setWorkType] = useState(null)
  const [task, setTask] = useState(null)
  const [status, setStatus] = useState(null)
  const [service, setService] = useState(null)

  // const [manualTitle, setManualTitle] = useState("")
  const [description, setDescription] = useState("")

  const [all_logs, setAllLogs] = useState([])

  const logTypeOptions = ["Scheduled", "Non-Scheduled"]
  const [logType, setLogType] = useState("Scheduled")

  const loggedin_user = secureLocalStorage.getItem("authUser") || {}

  // reset states
  useEffect(() => {
    if (!show) {
      setStartTime("")
      setEndTime("")
      setTotalHours("0.00")
      setClient(null)
      setService(null)
      setTask(null)
      setWorkType(null)
      setStatus(null)
      setDescription("")
    }
  }, [show])

  const getLogs = async () => {
    try {
      const response = await axiosbaseurl.get(`/task-updates/timesheet/logs`)

      if (response.data.success) {
        const logsdata = response.data.data
          .filter(
            item =>
              moment(item.createdAt).format("YYYY-MM-DD") ===
                moment().format("YYYY-MM-DD") &&
              Number(item?.employeeId) === Number(loggedin_user?.employeeId)
          )
          .map(item => ({
            ...item,
            employeeName:
              item?.employee?.name + " " + item?.employee?.lastName || "",
            timeSpent:
              calculateTimeDifference(item.startTime, item.endTime) + " hrs",
            statusName: item?.status?.statusName,
            serviceName: {
              id: item?.serviceId,
              serviceName: item?.serviceName,
            },
            serviceNameStr: item?.serviceName || "N/A",
            clientName: item?.clientName || item?.client?.clientName || "N/A",
          }))
          ?.sort((a, b) => a.id - b.id)

        setAllLogs(logsdata)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (show) getLogs()
  }, [show])

  // getting dropdown options common function
  async function getOptions(api) {
    try {
      const response = await axiosbaseurl.get(api)
      if (response.data.success) return response.data.data

      return false
    } catch (error) {
      console.log(error)
    }
  }

  // clients, tasks, status, worktypes
  // getting dropdown options
  useEffect(() => {
    if (show) {
      ;(async () => {
        try {
          let options = []

          options = await getOptions("/tasks")
          settasksOptions(
            options
              ?.slice()
              .sort((a, b) => a.title.localeCompare(b.title))
              .map(task => ({
                value: task.id,
                label: `${task.title} - ${moment
                  .utc(task.startDate)
                  .format("DD-MM-YYYY")}`,
                clientId: task.clientId,
                serviceId: task.serviceNameId,
              })) || []
          )

          options = await getOptions("/work-type/active")
          setworksTypeOptions(
            options
              ?.slice()
              .sort((a, b) => a.workType.localeCompare(b.workType))
              .map(work => ({
                value: work.id,
                label: work.workType,
              })) || []
          )

          options = await getOptions("/client")
          setclientOptions(
            options
              ?.slice()
              .sort((a, b) => a.clientName.localeCompare(b.clientName))
              .map(client => ({
                value: client.id,
                label: `${client.clientCode} - ${client.clientName}`,
                clientTypeId: client.clientTypeId,
              })) || []
          )

          options = await getOptions("/status-master/active")

          setstatusOptions(
            options
              ?.slice()
              .sort((a, b) => a.statusName.localeCompare(b.statusName))
              .map(sts => ({
                value: sts.id,
                label: sts.statusName,
                serviceIds: sts.serviceIds || [],
              })) || []
          )

          options = await getOptions("/service-master/active")
          setservicesOptions(
            options
              ?.filter(
                svc =>
                  svc.serviceCategory === "Non-Billiable and Non-scheduled" ||
                  svc.serviceCategory === "Billiable and Non-scheduled"
              )
              ?.slice()
              .sort((a, b) => a.serviceName.localeCompare(b.serviceName))
              .map(service => ({
                value: service.id,
                label: service.serviceName,
                clientTypeId: service.clientTypeId,
              })) || []
          )
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }, [show])

  // calculating total hours based on start & end times
  useEffect(() => {
    const calculateTotalTime = () => {
      const startMoment = moment(startTime, "HH:mm")
      const endMoment = moment(endTime, "HH:mm")

      // If the end time is before the start time, it means the end time is on the next day
      if (endMoment.isBefore(startMoment)) {
        endMoment.add(1, "days") // Add one day to the end time
      }

      // Calculate the difference in minutes
      const diffInMinutes = endMoment.diff(startMoment, "minutes")

      // Convert the difference to hours and minutes
      const hours = Math.floor(diffInMinutes / 60)
      const minutes = diffInMinutes % 60

      // Set total time in "hh:mm" format
      setTotalHours(
        `${hours < 10 ? "0" + hours : hours}:${
          minutes < 10 ? "0" + minutes : minutes
        }`
      )
    }
    if (startTime && endTime) calculateTotalTime()
  }, [startTime, endTime])

  function calculateTimeDifference(startTime, endTime) {
    // Parse the start and end times as moment objects
    const start = moment(startTime, "HH:mm")
    const end = moment(endTime, "HH:mm")

    // If end time is earlier than start time, add a day to end time
    if (end.isBefore(start)) {
      end.add(1, "days")
    }

    // Calculate the difference in minutes
    const duration = moment.duration(end.diff(start))

    // Get total hours and minutes
    const hours = String(Math.floor(duration.asHours())).padStart(2, "0") // Ensure two digits
    const minutes = String(duration.minutes()).padStart(2, "0") // Ensure two digits

    return `${hours}:${minutes}`
  }

  const filteredServices = React.useMemo(() => {
    if (logType !== "Non-Scheduled" || !client?.clientTypeId) {
      return servicesOptions
    }

    return servicesOptions.filter(
      svc => svc.clientTypeId === client.clientTypeId || svc.clientTypeId === 0
    )
  }, [logType, client, servicesOptions])

  const filteredStatusOptions = React.useMemo(() => {
    if (!task?.serviceId) return statusOptions

    const taskServiceId = Number(task.serviceId) // ensure number

    return statusOptions.filter(sts => {
      if (!sts.serviceIds) return false
      // Handle both array of numbers or strings
      return sts.serviceIds.some(id => Number(id) === taskServiceId)
    })
  }, [statusOptions, task?.serviceId])

  useEffect(() => {
    setStatus(null)
  }, [task])

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()

    // Validate based on log type
    if (logType === "Scheduled") {
      if (!client || !workType || !task || !status || !startTime || !endTime) {
        swal(
          "Validation Error",
          "All fields marked with * are required for Scheduled logs!",
          "warning"
        )
        return
      }
    } else {
      // Non-Scheduled
      if (!client || !workType || !service || !startTime || !endTime) {
        swal(
          "Validation Error",
          "All fields marked with * are required for Non-Scheduled logs!",
          "warning"
        )
        return
      }
    }

    if (totalHours === "00:00") {
      swal("Insufficient Total Time", "Minimum one minute expected", "warning")
      return
    }

    // Build form data after validation passes
    const formData = new FormData()

    if (task?.value) formData.append("taskId", task?.value)

    formData.append("workTypeId", workType?.value)
    if (status?.value) formData.append("statusId", status?.value)

    formData.append("startTime", startTime)
    formData.append("endTime", endTime)
    // formData.append("workDescription", description)
    if (logType === "Non-Scheduled")
      formData.append("serviceId", service?.value)

    formData.append("clientId", client?.value)

    if (logType === "Non-Scheduled")
      formData.append("title", "Non-Scheduled Log")

    try {
      setLoading(true)

      let response = await axiosbaseurl.post("/task-updates", formData)

      if (response.data.success) {
        swal("", `Report Saved successfully.`, "success")
        setStartTime("")
        setEndTime("")
        setTotalHours("0.00")
        setClient(null)
        setTask(null)
        setWorkType(null)
        setService(null)
        setStatus(null)
        setDescription("")
        getLogs()
      }
    } catch (error) {
      console.log(error)
      const msg =
        error.response.data.message || error.message || "Something went Wrong"

      swal(
        "",
        msg,
        msg.includes("No changes were made !") ? "warning" : "error"
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button
        onClick={() => {
          setShow(true)
        }}
        className="btn btn-primary btn-sm manual-logs-add-button"
      >
        <i className="mdi mdi-clipboard-edit-outline fs-2"></i>
      </button>

      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <form onSubmit={handleSubmit} className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-4">
              <h5 className="mb-0 text-white"> Add Manual Task Log</h5>
              <div>
                {/* <LoadingButton loading={loading} btn='light' /> */}
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="px-4 bg-light rounded-4 py-2">
              <div className="row ">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label>
                      Type <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 flex-row">
                      {logTypeOptions.map(type => (
                        <div
                          className="border border-primary rounded-2"
                          key={type}
                        >
                          <label
                            htmlFor={type}
                            className={` px-3 mb-0 input-field border text-nowrap
                                    ${
                                      logType === type
                                        ? "bg-primary text-white"
                                        : "bg-light"
                                    }`}
                          >
                            <input
                              type="radio"
                              className="me-2"
                              checked={logType === type}
                              onClick={() => {
                                setLogType(type)
                                if (type === logTypeOptions[0]) {
                                  setManualTitle("")
                                } else {
                                  setClient(null)
                                  setTask(null)
                                  setStatus(null)
                                }
                              }}
                              name="logType"
                              id={type}
                            />{" "}
                            <span>{type}</span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row border-bottom border-2 pb-4">
                <div className="col-md-3">
                  <div>
                    <label htmlFor="">
                      Client <span className="text-danger">*</span>{" "}
                    </label>
                    <Select
                      value={client}
                      onChange={e => setClient(e)}
                      options={clientOptions}
                      styles={customStyles}
                    />
                  </div>
                </div>
                {logType === logTypeOptions[0] ? (
                  <div className="col-md-3">
                    <div>
                      <label htmlFor="">
                        Task <span className="text-danger">*</span>{" "}
                      </label>
                      <Select
                        value={task}
                        onChange={e => setTask(e)}
                        options={
                          client?.value
                            ? tasksOptions?.filter(
                                tsk => tsk.clientId === client?.value
                              )
                            : []
                        }
                        isDisabled={!client}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-md-3">
                      <div>
                        <label htmlFor="">
                          Service <span className="text-danger">*</span>{" "}
                        </label>
                        <Select
                          value={service}
                          onChange={e => setService(e)}
                          options={filteredServices}
                          isDisabled={!client}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-4">
                      <div>
                        <label>
                          Start Time <span className="text-danger">*</span>
                        </label>

                        <input
                          type="time"
                          value={startTime}
                          onChange={e => {
                            setStartTime(e.target.value)
                          }}
                          className="form-control input-field"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                        <label>
                          End Time <span className="text-danger">*</span>
                        </label>
                        <input
                          type="time"
                          value={endTime}
                          onChange={e => {
                            setEndTime(e.target.value)
                          }}
                          className="form-control input-field"
                          // disabled={ids?.adminView}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div>
                        <label htmlFor="">Total's Hours</label>
                        {totalHours && (
                          <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                            {totalHours} {totalHours > 1 ? "s" : ""}
                            <sub className="fw-light fs-6">hrs</sub>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {logType === logTypeOptions[0] ? (
                  <div className="col-md-3 mt-3">
                    <div>
                      <label htmlFor="">
                        Status <span className="text-danger">*</span>{" "}
                      </label>
                      <Select
                        value={status}
                        onChange={e => setStatus(e)}
                        options={filteredStatusOptions}
                        styles={customStyles}
                        isDisabled={!task}
                        placeholder="Select status..."
                      />
                    </div>
                  </div>
                ) : null}

                <div className={`col-md-3 mt-3`}>
                  <div>
                    <label htmlFor="">
                      Work Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      value={workType}
                      onChange={e => setWorkType(e)}
                      options={worksTypeOptions}
                      styles={customStyles}
                    />
                  </div>
                </div>

                <div
                  className={`col-md-${
                    logType === logTypeOptions[0] ? "4" : "7"
                  } mt-3`}
                >
                  {/* <CustomEditor
                    content={description}
                    setContent={setDescription}
                    height={46}
                    allOptions={false}
                  /> */}
                </div>

                <div className="col-md-2 d-flex align-items-end pb-2">
                  <LoadingButton
                    loading={loading}
                    btn="primary"
                    btnText="Submit"
                  />
                </div>
              </div>
            </div>
            <div className="px-4 mt-3 ">
              <LogsOnPopup all_logs={all_logs} />
            </div>
          </ModalBody>
        </form>
      </Modal>
    </>
  )
}

export default AddManualLogs
